<template>
  <div>
    <Card>
      <template #content>
        <div class="d-flex flex-column align-items-center w-100">
          <TrainingShow
            v-if="training"
            :training="training"
            class="w-100"
            @mark-as-watched="handleMarkAsWatched"
            @send-watched-minutes="handleSendWatchedMinutes"
          />
          <div class="d-flex flex-wrap justify-content-center">
            <BasicButton
              label="戻る"
              class="me-5"
              outlined
              variant="secondary"
              @click="backto({ confirm: false })"
            />
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useTrainings, useRouterUtil } from "/@/vue/composables";
import { OpenSiteBackButton, BasicButton } from "/@/vue/components/Atom";
import { Show as TrainingShow } from "/@/vue/components/Molecules/Trainings";
import { errorHandle } from "/@/modules/error";
import { axios } from "/@/modules/axios";
import Card from "primevue/card";

const { currentRouteParams, backto } = useRouterUtil();

const id = computed(() => {
  return Number(currentRouteParams.value.id as string);
});

const { getTraining, markAsWatched, sendWatchedMinutes } = useTrainings();
const { data: training, error } = getTraining(id);

async function handleMarkAsWatched(id: number) {
  try {
    const response = await markAsWatched(id);
  } catch (e) {
    errorHandle(e);
  }
}

async function handleSendWatchedMinutes(minutes: number) {
  try {
    await sendWatchedMinutes(id.value, minutes);
  } catch (e) {
    errorHandle(e);
  }
}
</script>

<style scoped></style>
